import React from 'react';
import styled from 'styled-components';
import { FaCut, FaClock, FaPhone, FaMapMarkerAlt, FaCalendarAlt, FaStar } from 'react-icons/fa';
import DemoViewer from '../../components/DemoViewer';
import SEO from '../../components/SEO';

// Estilos para la demo de peluquería
const HairdresserDemo = styled.div`
  font-family: 'Montserrat', sans-serif;
  color: #333;
`;

const HeroSection = styled.div`
  background-image: url('/servicios/tipo-cliente/peluqueria-hero.webp');
  background-size: cover;
  background-position: center;
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 800px;
  padding: 0 2rem;
`;

const SalonName = styled.div`
  font-size: 2rem;
  font-weight: 300;
  margin-bottom: 1rem;
  letter-spacing: 5px;
  text-transform: uppercase;
`;

const HeroTitle = styled.h1`
  font-size: 4rem;
  margin-bottom: 1.5rem;
  font-weight: 700;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
`;

const HeroSubtitle = styled.p`
  font-size: 1.25rem;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
`;

const BookButton = styled.button`
  background-color: #fc6c8f;
  color: white;
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #e45c7b;
    transform: translateY(-3px);
  }
`;

const Section = styled.section`
  padding: 5rem 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  
  &::after {
    content: '';
    width: 80px;
    height: 3px;
    background-color: #fc6c8f;
    position: absolute;
    bottom: -1rem;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
`;

const ServiceCard = styled.div`
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const ServiceImage = styled.div`
  height: 200px;
  background-color: #eee;
  background-size: cover;
  background-position: center;
`;

const ServiceContent = styled.div`
  padding: 1.5rem;
`;

const ServiceTitle = styled.h3`
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ServicePrice = styled.span`
  color: #fc6c8f;
  font-weight: bold;
`;

const ServiceDescription = styled.p`
  color: #666;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const ServiceButton = styled.button`
  background-color: transparent;
  color: #fc6c8f;
  border: 1px solid #fc6c8f;
  padding: 0.75rem 1.5rem;
  font-size: 0.9rem;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #fc6c8f;
    color: white;
  }
`;

const AboutSection = styled(Section)`
  background-color: #f9f9f9;
`;

const AboutContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const AboutImage = styled.div`
  flex: 1;
  min-width: 300px;
  height: 450px;
  background-image: url('/servicios/tipo-cliente/peluqueria-about.webp');
  background-size: cover;
  background-position: center;
  border-radius: 8px;
`;

const AboutContent = styled.div`
  flex: 1;
  min-width: 300px;
`;

const AboutTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  position: relative;
  
  &::after {
    content: '';
    width: 80px;
    height: 3px;
    background-color: #fc6c8f;
    position: absolute;
    bottom: -1rem;
    left: 0;
  }
`;

const AboutText = styled.p`
  color: #666;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
`;

const StylisrSection = styled(Section)``;

const StylistsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 2rem;
`;

const StylistCard = styled.div`
  text-align: center;
`;

const StylistImage = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: #eee;
  margin: 0 auto 1.5rem;
  background-size: cover;
  background-position: center;
`;

const StylistName = styled.h3`
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
  color: #333;
`;

const StylistRole = styled.p`
  color: #fc6c8f;
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: 500;
`;

const StylistBio = styled.p`
  color: #666;
  font-size: 0.9rem;
  line-height: 1.6;
`;

const PricingSection = styled(Section)`
  background-color: #f9f9f9;
`;

const PriceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
`;

const PriceColumn = styled.div`
  flex: 1;
  min-width: 280px;
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
`;

const PriceColumnTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  color: #333;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
`;

const PriceItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px dashed #eee;
  
  &:last-child {
    border-bottom: none;
  }
`;

const ServiceName = styled.span`
  color: #333;
`;

const Price = styled.span`
  color: #fc6c8f;
  font-weight: bold;
`;

const GallerySection = styled(Section)``;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
`;

const GalleryItem = styled.div`
  height: 250px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
`;

const GalleryImage = styled.div`
  width: 100%;
  height: 100%;
  background-color: #eee;
  background-size: cover;
  background-position: center;
`;

const TestimonialsSection = styled(Section)`
  background-color: #f9f9f9;
  text-align: center;
`;

const TestimonialsContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const TestimonialCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
  text-align: left;
`;

const TestimonialText = styled.p`
  font-style: italic;
  color: #666;
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
`;

const TestimonialAuthor = styled.div`
  display: flex;
  align-items: center;
`;

const AuthorAvatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #eee;
  margin-right: 1rem;
  background-size: cover;
  background-position: center;
`;

const AuthorInfo = styled.div``;

const AuthorName = styled.h4`
  margin: 0 0 0.25rem;
  font-size: 1.1rem;
`;

const AuthorRating = styled.div`
  color: #f1c40f;
  font-size: 0.9rem;
`;

const ContactSection = styled(Section)`
  background-color: #2c3e50;
  color: white;
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const ContactCard = styled.div`
  padding: 2rem;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.05);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const ContactIcon = styled.div`
  font-size: 2.5rem;
  color: #fc6c8f;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const ContactTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  text-align: center;
`;

const ContactText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  text-align: center;
`;

const Footer = styled.footer`
  background-color: #1a252f;
  color: white;
  padding: 2rem;
  text-align: center;
  
  p {
    color: rgba(255, 255, 255, 0.6);
  }
`;

const PeluqueriasDemoPage: React.FC = () => {
  return (
    <>
      <SEO 
        title="Demo de Sitio Web para Peluquerías | Web a Bajo Coste"
        description="Visualiza cómo quedaría tu salón de belleza online con este ejemplo interactivo. Diseño optimizado para atraer clientes y gestionar citas."
        keywords="demo web peluquería, diseño web salón belleza, ejemplo web peluquería"
        canonical="https://webabajocoste.es/plantillas/peluqueria"
      >
        <meta name="robots" content="noindex, nofollow" />
      </SEO>
      
      <DemoViewer
        title="Demo Web para Peluquerías"
        subtitle="Visualiza cómo podría ser tu nueva web de peluquería o salón de belleza, diseñada para atraer nuevos clientes y mejorar la gestión de citas"
        domainName="https://tusalondebelleza.es"
        serviceLink="/servicios/diseno-web-peluqueria"
        serviceName="Peluquerías"
      >
        <HairdresserDemo>
          <HeroSection>
            <HeroContent>
              <SalonName>Le Chic</SalonName>
              <HeroTitle>Estilo y belleza</HeroTitle>
              <HeroSubtitle>Descubre un espacio donde el arte del cabello se combina con la última tendencia en cuidado personal. Tu belleza, nuestra prioridad.</HeroSubtitle>
              <BookButton>Reservar Cita</BookButton>
            </HeroContent>
          </HeroSection>
          
          <Section>
            <Container>
              <SectionTitle>Nuestros Servicios</SectionTitle>
              
              <ServicesGrid>
                <ServiceCard>
                  <ServiceImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-servicio1.webp")' }} />
                  <ServiceContent>
                    <ServiceTitle>
                      Corte y Peinado
                      <ServicePrice>Desde 25€</ServicePrice>
                    </ServiceTitle>
                    <ServiceDescription>
                      Corte personalizado según tu tipo de rostro y estilo, incluyendo lavado y peinado final.
                    </ServiceDescription>
                    <ServiceButton>Reservar</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
                
                <ServiceCard>
                  <ServiceImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-servicio2.webp")' }} />
                  <ServiceContent>
                    <ServiceTitle>
                      Color y Mechas
                      <ServicePrice>Desde 45€</ServicePrice>
                    </ServiceTitle>
                    <ServiceDescription>
                      Tinte completo, mechas, balayage o técnicas personalizadas para dar vida a tu cabello.
                    </ServiceDescription>
                    <ServiceButton>Reservar</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
                
                <ServiceCard>
                  <ServiceImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-servicio3.webp")' }} />
                  <ServiceContent>
                    <ServiceTitle>
                      Tratamientos Capilares
                      <ServicePrice>Desde 35€</ServicePrice>
                    </ServiceTitle>
                    <ServiceDescription>
                      Hidratación, reconstrucción y tratamientos especializados para cabello dañado o con necesidades específicas.
                    </ServiceDescription>
                    <ServiceButton>Reservar</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
                
                <ServiceCard>
                  <ServiceImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-servicio4.webp")' }} />
                  <ServiceContent>
                    <ServiceTitle>
                      Peinados para Eventos
                      <ServicePrice>Desde 50€</ServicePrice>
                    </ServiceTitle>
                    <ServiceDescription>
                      Peinados especiales para bodas, fiestas y eventos. Incluye prueba previa y accesorios básicos.
                    </ServiceDescription>
                    <ServiceButton>Reservar</ServiceButton>
                  </ServiceContent>
                </ServiceCard>
              </ServicesGrid>
            </Container>
          </Section>
          
          <AboutSection>
            <AboutContainer>
              <AboutImage />
              
              <AboutContent>
                <AboutTitle>Sobre Nosotros</AboutTitle>
                <AboutText>
                  En Le Chic llevamos más de 15 años dedicados a la belleza y el cuidado personal. Nuestro salón nació con la visión de ofrecer servicios de alta calidad adaptados a cada cliente.
                </AboutText>
                <AboutText>
                  Contamos con un equipo de profesionales en constante formación, que dominan las últimas técnicas y tendencias del sector. Utilizamos productos de primeras marcas, respetuosos con el medio ambiente y libres de crueldad animal.
                </AboutText>
                <AboutText>
                  Nuestro objetivo es que cada visita sea una experiencia placentera, donde puedas relajarte mientras te hacemos lucir radiante.
                </AboutText>
              </AboutContent>
            </AboutContainer>
          </AboutSection>
          
          <StylisrSection>
            <Container>
              <SectionTitle>Nuestro Equipo</SectionTitle>
              
              <StylistsGrid>
                <StylistCard>
                  <StylistImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluquero1.webp")' }} />
                  <StylistName>Laura García</StylistName>
                  <StylistRole>Directora y Estilista Senior</StylistRole>
                  <StylistBio>
                    Con más de 20 años de experiencia, Laura es experta en coloración y técnicas avanzadas de corte.
                  </StylistBio>
                </StylistCard>
                
                <StylistCard>
                  <StylistImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluquero2.webp")' }} />
                  <StylistName>Carlos Mendoza</StylistName>
                  <StylistRole>Estilista Creativo</StylistRole>
                  <StylistBio>
                    Especialista en peinados vanguardistas y técnicas de color modernas, creando looks únicos.
                  </StylistBio>
                </StylistCard>
                
                <StylistCard>
                  <StylistImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluquero3.webp")' }} />
                  <StylistName>Elena Torres</StylistName>
                  <StylistRole>Especialista en Color</StylistRole>
                  <StylistBio>
                    Experta en mechas y balayage, con un talento especial para encontrar el tono perfecto para cada piel.
                  </StylistBio>
                </StylistCard>
                
                <StylistCard>
                  <StylistImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluquero4.webp")' }} />
                  <StylistName>Javier Ruiz</StylistName>
                  <StylistRole>Estilista Unisex</StylistRole>
                  <StylistBio>
                    Especializado en cortes tanto femeninos como masculinos, con un estilo moderno y versátil.
                  </StylistBio>
                </StylistCard>
              </StylistsGrid>
            </Container>
          </StylisrSection>
          
          <PricingSection>
            <Container>
              <SectionTitle>Nuestras Tarifas</SectionTitle>
              
              <PriceContainer>
                <PriceColumn>
                  <PriceColumnTitle>Servicios para Mujer</PriceColumnTitle>
                  
                  <PriceItem>
                    <ServiceName>Corte y Peinado</ServiceName>
                    <Price>25€ - 35€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Tinte Completo</ServiceName>
                    <Price>45€ - 60€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Mechas</ServiceName>
                    <Price>55€ - 80€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Balayage</ServiceName>
                    <Price>75€ - 120€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Tratamiento Hidratante</ServiceName>
                    <Price>35€ - 50€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Peinado para Eventos</ServiceName>
                    <Price>50€ - 90€</Price>
                  </PriceItem>
                </PriceColumn>
                
                <PriceColumn>
                  <PriceColumnTitle>Servicios para Hombre</PriceColumnTitle>
                  
                  <PriceItem>
                    <ServiceName>Corte y Peinado</ServiceName>
                    <Price>18€ - 25€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Arreglo de Barba</ServiceName>
                    <Price>12€ - 18€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Corte + Barba</ServiceName>
                    <Price>28€ - 40€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Tinte Encubrimiento Canas</ServiceName>
                    <Price>30€ - 45€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Tratamiento Anticaída</ServiceName>
                    <Price>40€ - 60€</Price>
                  </PriceItem>
                  
                  <PriceItem>
                    <ServiceName>Afeitado Tradicional</ServiceName>
                    <Price>25€ - 35€</Price>
                  </PriceItem>
                </PriceColumn>
              </PriceContainer>
            </Container>
          </PricingSection>
          
          <GallerySection>
            <Container>
              <SectionTitle>Nuestra Galería</SectionTitle>
              
              <GalleryGrid>
                <GalleryItem>
                  <GalleryImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-galeria1.webp")' }} />
                </GalleryItem>
                
                <GalleryItem>
                  <GalleryImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-galeria2.webp")' }} />
                </GalleryItem>
                
                <GalleryItem>
                  <GalleryImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-galeria3.webp")' }} />
                </GalleryItem>
                
                <GalleryItem>
                  <GalleryImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-galeria4.webp")' }} />
                </GalleryItem>
                
                <GalleryItem>
                  <GalleryImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-galeria5.webp")' }} />
                </GalleryItem>
                
                <GalleryItem>
                  <GalleryImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-galeria6.webp")' }} />
                </GalleryItem>
                
                <GalleryItem>
                  <GalleryImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-galeria7.webp")' }} />
                </GalleryItem>
                
                <GalleryItem>
                  <GalleryImage style={{ backgroundImage: 'url("/servicios/tipo-cliente/peluqueria-galeria8.webp")' }} />
                </GalleryItem>
              </GalleryGrid>
            </Container>
          </GallerySection>
          
          <TestimonialsSection>
            <Container>
              <SectionTitle>Lo que dicen nuestros clientes</SectionTitle>
              
              <TestimonialsContainer>
                <TestimonialCard>
                  <TestimonialText>
                    "Llevo años viniendo a Le Chic y nunca me han decepcionado. Laura entiende perfectamente mi tipo de cabello y siempre consigue el color que busco. El ambiente es muy agradable y el servicio excepcional."
                  </TestimonialText>
                  <TestimonialAuthor>
                    <AuthorAvatar style={{ backgroundImage: 'url("/servicios/tipo-cliente/cliente1.webp")' }} />
                    <AuthorInfo>
                      <AuthorName>María Jiménez</AuthorName>
                      <AuthorRating>
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                      </AuthorRating>
                    </AuthorInfo>
                  </TestimonialAuthor>
                </TestimonialCard>
                
                <TestimonialCard>
                  <TestimonialText>
                    "Carlos hizo un trabajo increíble con mi cabello. Llegué con un desastre después de intentar teñirme en casa, y él lo transformó completamente. Además, me dio consejos muy útiles para mantenerlo en buen estado."
                  </TestimonialText>
                  <TestimonialAuthor>
                    <AuthorAvatar style={{ backgroundImage: 'url("/servicios/tipo-cliente/cliente2.webp")' }} />
                    <AuthorInfo>
                      <AuthorName>David López</AuthorName>
                      <AuthorRating>
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                      </AuthorRating>
                    </AuthorInfo>
                  </TestimonialAuthor>
                </TestimonialCard>
              </TestimonialsContainer>
            </Container>
          </TestimonialsSection>
          
          <ContactSection>
            <Container>
              <SectionTitle>Contacto</SectionTitle>
              
              <ContactGrid>
                <ContactCard>
                  <ContactIcon>
                    <FaMapMarkerAlt />
                  </ContactIcon>
                  <ContactTitle>Ubicación</ContactTitle>
                  <ContactText>
                    Calle Fuencarral, 58<br />
                    28004 Madrid
                  </ContactText>
                </ContactCard>
                
                <ContactCard>
                  <ContactIcon>
                    <FaClock />
                  </ContactIcon>
                  <ContactTitle>Horario</ContactTitle>
                  <ContactText>
                    Lunes a Viernes: 10:00 - 20:00<br />
                    Sábados: 10:00 - 18:00
                  </ContactText>
                </ContactCard>
                
                <ContactCard>
                  <ContactIcon>
                    <FaPhone />
                  </ContactIcon>
                  <ContactTitle>Reservas</ContactTitle>
                  <ContactText>
                    Teléfono: 912 345 678<br />
                    WhatsApp: 600 123 456
                  </ContactText>
                </ContactCard>
              </ContactGrid>
            </Container>
          </ContactSection>
          
          <Footer>
            <p>© 2023 Le Chic Salón de Belleza | Todos los derechos reservados</p>
          </Footer>
        </HairdresserDemo>
      </DemoViewer>
    </>
  );
};

export default PeluqueriasDemoPage; 